// Import language configuration from Sanity to keep in sync
// Note: Update this file when adding new languages to studio/src/config/languages.ts

import { Language, languages } from '@/lang'

export function isValidLocale(locale: string): locale is Language {
  return !!languages.find((item) => item.value === locale)
}

export function getLocaleFromPathname(pathname: string): Language {
  // Check if pathname starts with /es
  if (pathname === '/es' || pathname.startsWith('/es/')) {
    return 'es'
  }
  // Default to 'en' for all other paths
  return 'en'
}

export function removeLocalePrefix(pathname: string): string {
  // Remove /es prefix if present
  if (pathname === '/es') {
    return '/'
  }
  if (pathname.startsWith('/es/')) {
    return pathname.slice(3)
  }
  return pathname
}
